import { centsToDollars } from '../utils/formatters'

const CartDetailsViewModel = ({ subtotal, tax, total }) => {
  return {
    subtotal: centsToDollars(subtotal),
    tax: centsToDollars(tax),
    total: centsToDollars(total),
  }
}

export default CartDetailsViewModel
